import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../../../config/URL";
import { toast } from "react-toastify";

function StudentWithdrawView() {
  const { id } = useParams();
  const [data, setData] = useState([]);

  const getData = async () => {
    try {
      const response = await api.get(`/getAllStudentWithdrawClassById/${id}`);
      setData(response.data);
    } catch (error) {
      toast.error("Error Fetching Data ", error);
    }
  };

  useEffect(() => {
    getData();
  }, [id]);

  return (
    <div className="container-fluid">
      <ol
        className="breadcrumb my-3 px-2"
        style={{ listStyle: "none", padding: 0, margin: 0 }}
      >
        <li>
          <Link to="/" className="custom-breadcrumb">
            Home
          </Link>
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li>
          Student Management
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li>
          <Link to="/replaceclasslesson" className="custom-breadcrumb">
            Withdraw List
          </Link>
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          Withdraw List View
        </li>
      </ol>
      <div className="card">
        <div
          className="d-flex px-4 justify-content-between align-items-center p-1 mb-4"
          style={{ background: "#f5f7f9" }}
        >
          <div className="d-flex align-items-center">
            <div className="d-flex">
              <div className="dot active"></div>
            </div>
            <span className="me-2 text-muted">View Withdraw List</span>
          </div>
          <div className="my-2 pe-3 d-flex align-items-center">
            <Link to="/withdraw">
              <button type="button " className="btn btn-sm btn-border mx-2">
                Back
              </button>
            </Link>
          </div>
        </div>
        <div className="container-fluid px-4">
          <div className="row pb-3">
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">Course</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.course || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">Class</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.className || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">Teacher</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.userName || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">Day timing</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.dayTiming || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">Class Start date</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.classStartDate?.substring(0,10) || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">Class End Date</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.classEndDate?.substring(0,10) || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">Request Date</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.requestDate?.substring(0, 10) || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">Withdraw Reason</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.withdrawReason || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">Remark Parent</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.remarkParent || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">Remark Centre</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.remarkCenter || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">Last Lesson Date</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.lastLessonDate || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">Last paid lesson date</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.lastPaidLessonDate || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">No of lesson notice</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.noOfLessonNotice || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">No of lesson notice for refund</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.noOfLessonNoticeForRefund || ""}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row pb-3">
            <div className="col-md-12 col-12 mb-3">
              <span class="me-2 fw-medium" style={{ color: "#287f71" }}>
                Refund Detail
              </span>
            </div>
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">Refund Name</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.refundName || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">Refund Address</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.refundAddress || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">Refund Amount</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.refundAmount || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">Refund Mode</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.refundMode || ""}
                  </p>
                </div>
              </div>
            </div>
            {data.refundMode === "Cheque" && (
              <>
                <div className="col-md-6 col-12">
                  <div className="row  mb-2">
                    <div className="col-3  ">
                      <p className="fw-medium">Cheque No</p>
                    </div>
                    <div className="col-9">
                      <p className="text-muted text-sm d-flex text-break">
                        : {data.chequeNo || ""}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="row  mb-2">
                    <div className="col-3  ">
                      <p className="fw-medium">Cheque Date</p>
                    </div>
                    <div className="col-9">
                      <p className="text-muted text-sm d-flex text-break">
                        : {data.chequeDate || ""}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="row  mb-2">
                    <div className="col-3  ">
                      <p className="fw-medium">Cheque Amount</p>
                    </div>
                    <div className="col-9">
                      <p className="text-muted text-sm d-flex text-break">
                        : {data.chequeAmount || ""}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}
            {data.refundMode === "Bank Transfer" && (
              <>
                <div className="col-md-6 col-12">
                  <div className="row mb-2">
                    <div className="col-3">
                      <p className="fw-medium">Bank Name</p>
                    </div>
                    <div className="col-9">
                      <p className="text-muted text-sm d-flex text-break">
                        : {data.bankName || ""}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="row mb-2">
                    <div className="col-3">
                      <p className="fw-medium">Bank Account Name</p>
                    </div>
                    <div className="col-9">
                      <p className="text-muted text-sm d-flex text-break">
                        : {data.bankAccountName || ""}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="row mb-2">
                    <div className="col-3">
                      <p className="fw-medium">Bank Account Number</p>
                    </div>
                    <div className="col-9">
                      <p className="text-muted text-sm d-flex text-break">
                        : {data.bankAccountNumber || ""}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="col-md-6 col-12">
              <div className="row  mb-2">
                <div className="col-3  ">
                  <p className="fw-medium">Forfeit Amount</p>
                </div>
                <div className="col-9">
                  <p className="text-muted text-sm d-flex text-break">
                    : {data.forfeitAmount || ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="overflow-x-auto mb-2">
              <table className="min-w-full border border-gray-300">
                <tbody>
                  <tr>
                    <td className="border px-4 py-2 font-semibold">
                      Registration Fees
                    </td>
                    <td className="border px-4 py-2">
                      {data.registrationFees}
                    </td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2 font-semibold">
                      Deposit Amount
                    </td>
                    <td className="border px-4 py-2">{data.depositAmount}</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2 font-semibold">
                      Deposit Offset Amount
                    </td>
                    <td className="border px-4 py-2">
                      {data.depositOffsetAmount}
                    </td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2 font-semibold">
                      No of lesson to refund
                    </td>
                    <td className="border px-4 py-2">
                      {data.noOfLessonToRefund}
                    </td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2 font-semibold">
                      Course Fees Amount
                    </td>
                    <td className="border px-4 py-2">
                      {data.courseFeesAmount}
                    </td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2 font-semibold">
                      Material Fees Amount
                    </td>
                    <td className="border px-4 py-2">
                      {data.materialFeesAmount}
                    </td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2 font-semibold">
                      Total Refundable
                    </td>
                    <td className="border px-4 py-2">
                      {data.totalRefundableAmount}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentWithdrawView;
